<div class="pipeline">
	@for (item of pipelineToArray(pipeline); track item) {
		<div class="item" [ngClass]="{ active: pipelineStep == item?.value }">
			@if (pipelineStep !== item?.value) {
				<img src="/assets/icons/svg/future-step.svg" alt="" loading="lazy" />
			}
			@if (pipelineStep == item?.value) {
				<img src="/assets/icons/svg/current-step.svg" alt="" loading="lazy" />
			}
			{{ item?.label }}
		</div>
	}
</div>
